export default "__VITE_ASSET__DqNm5$jX__"